import { groq } from "next-sanity";
import { NextSeo } from "next-seo";
import { getClient } from "../../../lib/sanity.server";
import Newsletter from "../../../view/components/Footer/components/Newsletter/Newsletter";
import Footer from "../../../view/components/Footer/Footer";
import Header from "../../../view/components/Header/Header";
import Hero from "../../../view/screens/Blog/components/Hero";
import Content from "../../../view/screens/Blog/components/Content/Content";
import Sidebar from "../../../view/screens/Blog/components/Sidebar/Sidebar";
import ServerPagination from "../../../view/components/ServerPagination/ServerPagination";

export default function BlogPage({ posts, page, total }) {
    return (
        <div>
            <Header />
            <NextSeo title="Dzobs.com Blog" description="Savjeti, vijesti i zanimljivosti za IT zajednicu" canonical={`https://www.dzobs.com/blog/`} />
            <Hero
                title="Blog"
                subtitle="Saznaj šta je novo u domaćoj IT zajednici, nauči kako da unaprijediš karijeru, te koje firme i trendove vrijedi pratiti."
            />
            <div className="max-w-screen-xl mx-auto px-6 xl:px-0 ">
                <div className="mb-8 leading-loose">
                    <section className="flex flex-col md:flex-row md:space-x-16 body-font overflow-hidden">
                        <div className="md:w-2/3">
                            <Content posts={posts} isHome={true} title={`Strana ${page}`} />
                            <ServerPagination perPage={7} activePage={page} total={total} />
                        </div>
                        <Sidebar />
                    </section>
                </div>
            </div>
            <Newsletter bg="bg-gray-light" />
            <Footer />
        </div>
    );
}

export async function getStaticPaths() {
    const postsTotal = await getClient().fetch(
        groq`
      count(*[_type == "post"])`
    );

    const numOfPages = Math.ceil(postsTotal - 3 / 8);

    const paths = Array.from(Array(numOfPages).keys()).map((k) => ({
        params: { page: (k + 1).toString() },
    }));

    return {
        paths,
        fallback: "blocking",
    };
}
export async function getStaticProps({ params }) {
    const { page } = params;
    const featuredPostsCount = 3;

    const start = page === 1 ? 0 : 7 * (page - 1) + featuredPostsCount;
    const end = page * 7 + featuredPostsCount;

    const posts = await getClient().fetch(
        groq`
      *[_type == "post"] {
        _id,
        title,
        publishedAt,
        body,
        author ->{
          name,
          image,
          title,
          slug
        },
        mainImage,
        categories[]->{
          _id,
          title,
          slug
        },
        slug
      } | order(publishedAt desc) [$start...$end]
      `,
        { start, end }
    );

    const postsTotal = await getClient().fetch(
        groq`
    count(*[_type == "post"])`
    );

    return {
        props: {
            posts,
            page,
            total: postsTotal - featuredPostsCount,
        },
        revalidate: 10,
    };
}
